export const locale = {
    lang: 'fr',
    data: {
        'NAV': {
            'ADMIN': 'Administrateur',
            'USER': 'Utilisateur',
            'ADHERANT': 'Adhérant',
            'EXPORTASSURANCE': 'Liste des contrats d\'assurance',
            'GESTIONEVENT': 'Gestion des événements',
            'LISTEVENT': 'Liste des événements',
            'GESTIONUSER': 'Gestion des membres',
            'GESTIONENTREPRISE': 'Gestion des sociétés',
            'PROFILE': 'Mon profil',
            'LISTPAIEMENT': 'Liste des paiements',
            'COTISATION': 'Ma cotisation',
            'GESTIONCONVENTION': 'Conventions et documents partagés',
            'LISTCONVENTION': 'Conventions et documents partagés',
            'ASSURANCE': 'Assurance',
            'ACTUALITE': 'Fil d\'actualités',
            'TRACABILITY': 'Traçabilités',
            'GESTIONCOTISATION': 'Gestion cotisation',
            'LISTTRAINEE': "Liste des stagiaires",
            'LISTREQUEST': "Liste des demandes",
            'TRAINEE': 'Liste des demandes de stage',
            "PARAMETRE":"Paramétrage",
            'LISTDIPLOME': "Liste des diplômes",
            'STAGE': "Cadre de stage",
            "DOCS":"Gestion des documents",
            "MODS":"Gestion des modules",
            'REQUESTLIST': 'Liste des demandes de stage',
            'TRAINEELIST': 'Liste des stagiaires',
            'CONTROLEUR': 'Contrôleur',
            'MODELE_COMPTE_RENDU': 'Modèle compte rendu',
            'COMPTABLE': 'Comptable',
            'TECHNICIEN_COMPTABLE': 'Technicien comptable',
            'SOCIETE': 'Société',
            'GESTIONCOTISATIONCARTES': 'Gestion des attestations et des cartes',
            'CHANGEPASSWORD': 'Modifier mot de passe',
        }
    }
};
